import { render, staticRenderFns } from "./PhoFileUploadPreview.vue?vue&type=template&id=7538e51b&lang=pug"
import script from "./PhoFileUploadPreview.vue?vue&type=script&lang=js"
export * from "./PhoFileUploadPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports